<template>
   <div>
    <h1>Create subscription:</h1>
    <card
      class="stripe-card"
      :class="{ complete }"
      stripe="pk_test_ZYclzxvLy3gH5nYLXyZdikyb00aouyZhag"
      :options="stripeOptions"
      @change="complete = $event.complete"
    />

    <button class="pay-with-stripe" @click="createSubscription" :disabled="!complete">Pay with credit card</button>
  </div>
</template>

<script>
import { Card } from 'vue-stripe-elements-plus'

export default {
  name: 'CreateSubscription',
  components: {
    Card
  },
  computed: {
    projects () {
      return this.$store.state.projects
    }
  },
  data () {
    return {
      complete: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      }
    }
  },
  methods: {
    async createSubscription () {
      this.$store.dispatch('createSubscription')
    }
  }
}

</script>

<style scoped lang="scss">
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
</style>
